/*global
    Stripe, appConfig
*/
(function($){

    'use strict';
    $(document).ready(function() {
	if (typeof Stripe !== 'undefined' && typeof window?.appConfig?.stripe?.publishableKey !== 'undefined') {
          //stripe loaded!
        var stripe = Stripe(appConfig.stripe.publishableKey);
        var elements = stripe.elements();
        var $form = $('form#stripe-form');
        if (typeof $form !== 'undefined' && $form.length > 0) { 
            var submitButton = $form.find("button.submit-button");
            var allInputs = $form.find("input");

            function registerElements(elements, exampleName) {
              var formClass = '.' + exampleName;
              var example = document.querySelector(formClass);

              var form = example.querySelector('form');
              var error = form.querySelector('.error');
              var errorMessage = error.querySelector('.message');

              function enableInputs() {
                Array.prototype.forEach.call(
                  form.querySelectorAll(
                    "input[type='text'], input[type='email'], input[type='tel']"
                  ),
                  function(input) {
                    input.removeAttribute('disabled');
                  }
                );
              }

              function disableInputs() {
                Array.prototype.forEach.call(
                  form.querySelectorAll(
                    "input[type='text'], input[type='email'], input[type='tel']"
                  ),
                  function(input) {
                    input.setAttribute('disabled', 'true');
                  }
                );
              }

              function triggerBrowserValidation() {
                // The only way to trigger HTML5 form validation UI is to fake a user submit
                // event.
                var submit = document.createElement('input');
                submit.type = 'submit';
                submit.style.display = 'none';
                form.appendChild(submit);
                submit.click();
                submit.remove();
              }
              allInputs.blur(function () {
                maybeEnableSubmit();
              });
              var enableButton = function () {
                if (typeof window.stripeFormCanEnable !== 'undefined' && !window.stripeFormCanEnable) {
                    return false;
                }
                submitButton.removeClass("btn-disabled");
                submitButton.addClass("btn-primary");
                submitButton.prop('disabled', false);
              }

              var disableButton = function () {
                submitButton.addClass("btn-disabled");
                submitButton.removeClass("btn-primary");
                submitButton.prop('disabled', true);
                window.stripeFormCanEnable = false;
              }

              var maybeEnableSubmit = function () {
                if (validateInputs() === true) {
                  enableButton();
                  return true;
                } else {
                  disableButton();
                  return false;
                }
              }
              var validateInputs = function () {
                var stripeInputs = $("#card-element");
                var valid = true;

                allInputs.each(function () {
                  var inputField = $(this);
                  if (inputField[0].name !== "stripeToken" && inputField[0].name !== "") {
                    if (inputField) {
                      if (inputField.val() == "" || inputField.val().length < 1) {
                        valid = false;
                      }
                    }
                  }
                });

                return valid;
              }
              // Listen for errors from each Element, and show error messages in the UI.
              var savedErrors = {};
              elements.forEach(function(element, idx) {
                element.on('change', function(event) {
                  if (event.error) {
                    error.classList.add('visible');
                    savedErrors[idx] = event.error.message;
                    errorMessage.innerText = event.error.message;
                    window.stripeFormCanEnable = true;
                  } else {
                    savedErrors[idx] = null;
            
                    // Loop over the saved errors and find the first one, if any.
                    var nextError = Object.keys(savedErrors)
                      .sort()
                      .reduce(function(maybeFoundError, key) {
                        return maybeFoundError || savedErrors[key];
                      }, null);
            
                    if (nextError) {
                      // Now that they've fixed the current error, show another one.
                      errorMessage.innerText = nextError;
                    } else {
                      // The user fixed the last error; no more errors.
                      error.classList.remove('visible');
                      maybeEnableSubmit();
                    }
                  }
                });
              });
            
              // Listen on the form's 'submit' handler...
              form.addEventListener('submit', function(e) {
                e.preventDefault();
                console.log('submitting...');
                disableButton();
                window.stripeFormCanEnable = false;
            
                // Trigger HTML5 validation UI on the form if any of the inputs fail
                // validation.
                var plainInputsValid = true;
                Array.prototype.forEach.call(form.querySelectorAll('input'), function(
                  input
                ) {
                  if (input.checkValidity && !input.checkValidity()) {
                    plainInputsValid = false;
                    return;
                  }
                });
                if (!plainInputsValid) {
                  triggerBrowserValidation();
                  return;
                }
            
                // Show a loading screen...
                example.classList.add('submitting');
            
                // Disable all inputs.
                disableInputs();
            
                // Gather additional customer data we may have collected in our form.
                var name = form.querySelector('#cardholder-name');
                var additionalData = {
                  name: name ? name.value : undefined
                };
            
                // Use Stripe.js to create a token. We only need to pass in one Element
                // from the Element group in order to create a token. We can also pass
                // in the additional customer data we collected in our form.
                stripe.createToken(elements[0], additionalData).then(function(result) {
                  // Stop loading!
                  example.classList.remove('submitting');
            
                  if (result.token) {
                    // If we received a token, show the token ID.
                    $('input[name="stripeToken"]').val(result.token.id);
                    $('form#stripe-form').submit();
                    example.classList.add('submitted');
                  } else {
                    // Otherwise, un-disable inputs.
                    window.stripeFormCanEnable = true;
                    enableInputs();
                    enableButton();
                  }
                });
              });
            }

            var elements = stripe.elements({
              fonts: [
                {
                  cssSrc: 'https://fonts.googleapis.com/css?family=Source+Code+Pro',
                },
              ],
              // Stripe's examples are localized to specific languages, but if
              // you wish to have Elements automatically detect your user's locale,
              // use `locale: 'auto'` instead.
              locale: window.__exampleLocale
            });
          
            // Floating labels
            var inputs = document.querySelectorAll('.cell.example.example2 .input');
            Array.prototype.forEach.call(inputs, function(input) {
              input.addEventListener('focus', function() {
                input.classList.add('focused');
              });
              input.addEventListener('blur', function() {
                input.classList.remove('focused');
              });
              input.addEventListener('keyup', function() {
                if (input.value.length === 0) {
                  input.classList.add('empty');
                } else {
                  input.classList.remove('empty');
                }
              });
            });
          
            var elementStyles = {
              base: {
                color: '#32325D',
                fontWeight: 500,
                fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
                fontSize: '16px',
                fontSmoothing: 'antialiased',
          
                '::placeholder': {
                  color: '#CFD7DF',
                },
                ':-webkit-autofill': {
                  color: '#e39f48',
                },
              },
              invalid: {
                color: '#E25950',
          
                '::placeholder': {
                  color: '#FFCCA5',
                },
              },
            };
          
            var elementClasses = {
              focus: 'focused',
              empty: 'empty',
              invalid: 'invalid',
            };
          
            var cardNumber = elements.create('cardNumber', {
              style: elementStyles,
              classes: elementClasses,
            });
            cardNumber.mount('#example2-card-number');
          
            var cardExpiry = elements.create('cardExpiry', {
              style: elementStyles,
              classes: elementClasses,
            });
            cardExpiry.mount('#example2-card-expiry');
          
            var cardCvc = elements.create('cardCvc', {
              style: elementStyles,
              classes: elementClasses,
            });
            cardCvc.mount('#example2-card-cvc');
          
            registerElements([cardNumber, cardExpiry, cardCvc], 'example2');
            function setOutcome(result) {
              var errorElement = document.querySelector('.error');
              errorElement.classList.remove('visible');

              if (result.token) {
                // Use the token to create a charge or a customer
                // https://stripe.com/docs/charges
                $('input[name="stripeToken"]').val(result.token.id);
                $('form#stripe-form').find('input').val('');
                $('form#stripe-form').submit();
              } else if (result.error) {
                errorElement.textContent = result.error.message;
                errorElement.classList.add('visible');
              }
            }
          }
	}
  });
}(jQuery));
